module.exports = __webpack_public_path__ + "static/media/5.c31cc493.JPG";